import CategoryIcon from '../../map/CategoryIcon';
import {buildCssUrlString} from "../../../utils/StringUtilities";
import ErrorBlock from "./ErrorBlock";
import {observer} from "mobx-react";
import {getPictureUrl, getLogoUrl} from "./blockUtils";
import {IBlockComponentProps} from "./_Block";
import ImageComponent from "../../utilities/ImageComponent";

interface IOrganizationBlockProps extends IBlockComponentProps {
    blockObj: IOrganizationBlockObj
}

const OrganizationBlock = observer((props: IOrganizationBlockProps) => {

    try {
        const { blockObj } = props;

        const orgModel = blockObj.blockModel;
        const orgDetail = orgModel.detail || {};
        const orgLocations = orgModel.locations || [];

        let details,
            categoryIcons,
            image,
            location;

        if (orgDetail && orgDetail.grade_start && orgDetail.grade_end) {
            details = <p className="sb-school-grades sb-hidden-xs">
                Grades&nbsp;
                <span id={'org-grade_start-' + orgModel.id}>{orgDetail.grade_start}</span>
                &nbsp;-&nbsp;
                <span id={'org-grade_end-' + orgModel.id}>{orgDetail.grade_end}</span>
            </p>
        }

        if (orgModel.all_categories?.length && orgModel.all_categories.length > 0) {
            categoryIcons = orgModel.all_categories.map((category) => {
                return (
                    <div key={category.id} className="sb-block-icon" style={{background: "transparent"}}>
                        <span>
                            <CategoryIcon category={category}/>
                        </span>
                    </div>
                );
            });
        }


        if (orgLocations && orgLocations.length > 0) {
            const orgLocation = orgLocations[0];
            location = <p className="sb-school-city sb-hidden-xs notranslate">{orgLocation.city}, {orgLocation.state}</p>
        }

        const imageUrl = getPictureUrl(orgModel);

        if (imageUrl) {
            const isDefaultSchoolImage = /_next\/static\/media\/school_photo/.test(imageUrl);
            if (isDefaultSchoolImage) {
                image = <ImageComponent className="sb-school-default-image" src={imageUrl} alt={orgModel.title} />;
            } else {
                image = <div className="sb-school-image-full-size"
                             style={{
                                 backgroundImage: buildCssUrlString(imageUrl),
                                 backgroundSize: orgModel.type === "organization" ? "contain" : "cover",
                }}
                             title={orgModel.title} />;
            }
        }

        return (
            <div className="sb-school">
                <div className="sb-block-container">
                    <div className="sb-block-icon-container">
                        {categoryIcons}
                    </div>
                    <div className="sb-school-image-container">
                        {image}
                    </div>
                    <div className="sb-blockMeta" style={{backgroundColor: '#fff'}}>
                        <div className="sb-blockMeta-content">
                            <p className="sb-school-title notranslate" id={'org-title-' + orgModel.id}>{orgModel.title}</p>
                            {details}
                            {location}
                        </div>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        return <ErrorBlock blockObj={{errorMessage: error}} />
    }
})

export default OrganizationBlock;
